import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
menu;
http: HttpClient;
  constructor(public http2: HttpClient) {

  }

  ngOnInit() {

  }
  
  /*
  public funcMenu() {
    this.http2.post('/menuGDL/', '')
    .subscribe( (result: any) => {
      if (result) {
        let menuGDL = '';
        // tslint:disable-next-line:only-arrow-functions
        result.menuGDL.forEach(function(value: any, key: any) {
          let tsubmenus = value.submenus.length;
          let submenus = '';
          if (tsubmenus > 0) {
            // tslint:disable-next-line:max-line-length
            tsubmenus = ' class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" role="button" aria-haspopup="true" aria-expanded="false" ';
            // tslint:disable-next-line:only-arrow-functions
            value.submenus.forEach(function(svalue, skey) {
              submenus = submenus + '<li><a href="' + svalue.ruta + '">' + svalue.menu + '</a></li>';
           });
            submenus = '<ul class="dropdown-menu">' + submenus + '</ul>';
         } else {
           tsubmenus = '';
         }
          // tslint:disable-next-line:max-line-length
          menuGDL = menuGDL + '<li class="dropdown"><a href="' + value.ruta + '" ' + tsubmenus + '>' + value.menu + '</a>' + submenus + '</li>';
       });
        return this.menu = menuGDL;
      } else {
        return null;
      }
  });
  }
  */

}
